<template>
  <el-dialog
    class="dialog-inner-scroller"
    :model-value="visible"
    :before-close="() => {
      emit('close');
    }"
    width="800"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
          汇款充值
        </h4>
      </div>
    </template>

    <div class="px-2 pb-3">
      <div class="info-title">
        请您根据以下账户信息进行公对公汇款，汇款成功后可前往余额查看到账情况
      </div>

      <div class="info-card">
        <div class="flex justify-between">
          <div>
            <span class="info-tag">户名: </span>
            <span>{{ data.serverName }}</span>
          </div>
          <el-button type="default" link @click="doCopyLine(data.serverName)">
            <svg-icon icon="lucide:copy" />
            复制
          </el-button>
        </div>
        <div class="flex justify-between">
          <div>
            <span class="info-tag">账号: </span>
            <span>{{ data.accountNo }}</span>
          </div>
          <el-button type="default" link @click="doCopyLine(data.accountNo)">
            <svg-icon icon="lucide:copy" />
            复制
          </el-button>
        </div>
        <div class="flex justify-between">
          <div>
            <span class="info-tag">支行: </span>
            <span>{{ data.openingBank }}</span>
          </div>
          <el-button type="default" link @click="doCopyLine(data.openingBank)">
            <svg-icon icon="lucide:copy" />
            复制
          </el-button>
        </div>
      </div>

      <div class="flex justify-end">
        <el-button type="primary" @click="doCopy">
          复制信息
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { SvgIcon } from '@vue3/components';
import { computed, PropType } from 'vue';
import { IFinanceWallet } from '@core/main/types';
import { useClipboard } from '@vueuse/core';
import { ElMessage } from 'element-plus';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object as PropType<IFinanceWallet>,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const source = computed(() => {
  return `户名: ${props.data.serverName}
账号: ${props.data.accountNo}
支行: ${props.data.openingBank}`;
});

const { copy } = useClipboard({ source });

const doCopyLine = (line: string) => {
  copy(line);
  ElMessage.success('复制成功');
};

const doCopy = () => {
  copy(source.value);
  ElMessage.success('复制成功');
};
</script>

<style lang="scss" scoped>
.info-mini {
  font-size: 12px;
  line-height: 21px;
}

.info-title {
  font-size: 16px;
  font-weight: 700;
}

.info-card {
  border-radius: 8px;
  border: 1px #ddd solid;
  margin: 16px 0;
  box-sizing: border-box;
  padding: 10px 18px;
  line-height: 22px;

  & > div {
    padding: 6px 0;
  }

  span {
    color: #333;

    &.info-tag {
      width: 40px;
      display: inline-block;
      color: #777;
      margin-right: 10px;
    }
  }
}
</style>
